import { applyMiddleware, combineReducers, createStore, Store } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'

import asyncReducers, { combineReducersAsync } from './remote'

import CompanyReducer from './company/reducers'
import TableroReducer from './tablero-seleccion/reducers'
import ModalReducer from './modal/reducers'
import HeaderReducer from './header/reducers'
import TalentPoolReducer from './talent-pool/reducers'
import CurriculumReducer from './curriculum/reducers'
import EstadisticasReducer from './aviso/estadisticas/reducers'
import LeadReducer from './lead/reducers'
import LocationsReducer from './locations/reducers'
import PostulacionesReducer from './dashboard/postulaciones/reducers'
import DashboardEstadisticasReducer from './dashboard/estadisticas/reducers'
import DashboardContactoReducer from './dashboard/contacto/reducers'
import usersReducer from './usuarios/reducers'
import FutureTalentsReducer from './future-talents/reducers'
import SnackbarReducer from './snackbar/reducers'
import CompanyProfileReducer from './company-profile/reducers'
import LogAccesosReducer from './log-acceso/reducers'
import CompanyHomeReducer from './home/reducers'
import ScrollMobileProductsReducer from './scroll-landing-products/reducers'
import AuthReducer from './auth/reducers'
import SignUpReducer from './sign-up/reducers'
import CondicionesIvaReducer from './condiciones-iva/reducers'
import IndustriasReducer from './industrias/reducers'
import AreasReducer from './areas/reducers'
import SubAreasReducer from './subareas/reducers'
import ForgotPasswordReducer from './forgot-password/reducers'
import RangosEmpleadosReducer from './rangos-empleados/reducers'
import ChangePasswordReducer from './change-password/reducers'
import EmailValidationReducer from './email/reducers'
import AjustesReducer from './ajustes/reducers'
import MyProfileReducer from './my-profile/reducer'
import CompraOnlineReducer from './ecommerce/compra-online/reducers'
import StockReducer from './stock/reducers'
import PaisesReducer from './paises/reducers'
import ProvinciasReducer from './provincias/reducers'
import LocalidadesReducer from './localidades/reducers'
import AvisoPublicacionReducer from './aviso-publicacion/reducers'
import AvisosReducer from './avisos/reducers'
import AvisosFiltradosReducer from './avisos-filtrados/reducers'
import ValidateAccountMail from './validate-account/reducers'
import NotificationReducer from './notification/reducers'
import { getCompanyData } from './company/actionsToDo'
import CurrencyReducer from './currency/reducers'
import ListNameMetricsReducer from './ecommerce/metrics/reducers'
// import IsCompanyLoggedIn from '../constants/getCompanyIsLoggued'
import ResumenCuentaReducer from './resumen-cuenta/reducer'
import VendorReducer from './ecommerce/vendor/reducers'
import TaxesReducer from './ecommerce/taxes/reducers'
import MotivosFinalizacionReducer from './motivos-finalizacion/reducers'
import PermisosAvisoReducer from './aviso-permisos/reducers'
import ModalidadesReducer from './modalidades-trabajo/reducers'
import ContratacionesReducer from './contrataciones/reducers'
import TrabajosReducer from './tipos-trabajos/reducers'
import NivelesLaboralesReducer from './niveles-laborales/reducers'
import TiposEstudioReducer from './tipos-estudio/reducers'
import EstadosEstudioReducer from './estados-estudio/reducers'
import NombreEmpresaReducer from './empresa-nombre/reducers'
import IdiomasReducer from './idiomas/reducers'
import NivelesIdiomaReducer from './niveles-idioma/reducers'
import GenerosReducer from './generos/reducers'
import PreguntasPredefinidasReducer from './preguntas-predefinidas/reducers'
import AvisoReducer from './aviso/aviso/reducers'
import bumiReducer from './bumi'
import CvsRecomendados from './recomendacionesCV/reducers'
import CurriculumsSelectaReducer from './selecta/cvs/reducers'
import CurriculumSelectaReducer from './selecta/cv/reducers'
import CartV2Reducer from './cart-v2'
import CouponReducer from './coupon/reducers'
import PlanPublicacionReducer from './planes-publicacion/reducer'
import PurchaseReducer from './ecommerce/purchase/reducers'
import DatosFacturacionClienteReducer from './ecommerce/datos-facturacion/reducers'
import PrivateRouteReducer from './private-routes/reducers'
import DataByConsumoCreditoCompraReducer from './ecommerce/by-consumo-credito/reducers'
import EstadisticasGeneralesReducer from './estadisticas/reducers'
import MensajesReducer from './mensajes/reducers'

/**
 *  habría que pensar bien como modular de mejor forma el store, por ahora
    CvsRecomendados queda como un store aparte, por que los cambios que generarían
    en el store de Curriculum salen del scope del pbi
 const curriculumCombineReducers = combineReducers({
   cvStore: CurriculumReducer,
   recomendadosStore: CvsRecomendados,
 })
 */

export const reducers = {
  companyStore: CompanyReducer,
  tableroSeleccionStore: TableroReducer,
  modalStore: ModalReducer,
  headerStore: HeaderReducer,
  talentPoolStore: TalentPoolReducer,
  curriculumStore: CurriculumReducer,
  CvsRecomendadosStore: CvsRecomendados,
  estadisticasStore: EstadisticasReducer,
  leadStore: LeadReducer,
  locationsStore: LocationsReducer,
  dashboardPostulacionesStore: PostulacionesReducer,
  dashboardEstadisticasStore: DashboardEstadisticasReducer,
  dashboardContactoStore: DashboardContactoReducer,
  usersStore: usersReducer,
  ajustesStore: AjustesReducer,
  futureTalentsStore: FutureTalentsReducer,
  snackbarStore: SnackbarReducer,
  companyProfileStore: CompanyProfileReducer,
  myProfileStore: MyProfileReducer,
  logAccesosStore: LogAccesosReducer,
  scrollMobileProductsStore: ScrollMobileProductsReducer,
  companyHomeStore: CompanyHomeReducer,
  authStore: AuthReducer,
  compraOnlineStore: CompraOnlineReducer,
  signUpStore: SignUpReducer,
  condicionesIvaStore: CondicionesIvaReducer,
  industriasStore: IndustriasReducer,
  areasStore: AreasReducer,
  subAreasStore: SubAreasReducer,
  rangosEmpleadosStore: RangosEmpleadosReducer,
  forgotPasswordStore: ForgotPasswordReducer,
  changePasswordStore: ChangePasswordReducer,
  emailValidationStore: EmailValidationReducer,
  paisesStore: PaisesReducer,
  provinciasStore: ProvinciasReducer,
  localidadesStore: LocalidadesReducer,
  validateAccountStore: ValidateAccountMail,
  cartStoreV2: CartV2Reducer,
  stockStore: StockReducer,
  avisoPublicacionStore: AvisoPublicacionReducer,
  currencyStore: CurrencyReducer,
  listNameMetricStore: ListNameMetricsReducer,
  notificationStore: NotificationReducer,
  avisosStore: AvisosReducer,
  resumenCuentaStore: ResumenCuentaReducer,
  avisosFiltradosStore: AvisosFiltradosReducer,
  vendorStore: VendorReducer,
  taxesStore: TaxesReducer,
  motivosFinalizacionStore: MotivosFinalizacionReducer,
  permisosAvisoStore: PermisosAvisoReducer,
  modalidadesStore: ModalidadesReducer,
  contratacionesStore: ContratacionesReducer,
  trabajosStore: TrabajosReducer,
  nivelesLaboralesStore: NivelesLaboralesReducer,
  tiposEstudioStore: TiposEstudioReducer,
  estadosEstudioStore: EstadosEstudioReducer,
  nombreEmpresaStore: NombreEmpresaReducer,
  idiomasStore: IdiomasReducer,
  nivelesIdiomaStore: NivelesIdiomaReducer,
  generosStore: GenerosReducer,
  preguntasPredefinidasStore: PreguntasPredefinidasReducer,
  bumiStore: bumiReducer,
  curriculumsSelectaStore: CurriculumsSelectaReducer,
  curriculumSelectaStore: CurriculumSelectaReducer,
  avisoStore: AvisoReducer,
  couponStore: CouponReducer,
  planPublicacionStore: PlanPublicacionReducer,
  purchaseStore: PurchaseReducer,
  datosFacturacionStore: DatosFacturacionClienteReducer,
  privateRouteStore: PrivateRouteReducer,
  dataByConsumoCreditoCompraStore: DataByConsumoCreditoCompraReducer,
  estadisticasGeneralesStore: EstadisticasGeneralesReducer,
  mensajesStore: MensajesReducer,
}

const rootReducer = combineReducers({
  ...reducers,
})

export type AppStore = ReturnType<typeof rootReducer>

function configureStore() {
  const middlewares = [thunkMiddleware]
  const middleWareEnhancer = applyMiddleware(...middlewares)
  return createStore(rootReducer, composeWithDevTools(middleWareEnhancer))
}

export const store = configureStore()

combineReducersAsync(reducers, ...asyncReducers).then(store.replaceReducer)

/**
 * fillStore
 *
 * @param path
 */
export const fillStore = (storeToFill = store) => {
  /**
   * primero se valida que el usuario este logueado,
   * mediante las cookies
   */
  // if (IsCompanyLoggedIn()) {
  //   if (!store.getState().companyStore.companyData) {
  //     store.dispatch(getCompanyData())
  //   }
  // }

  if (!storeToFill.getState().companyStore.companyData) {
    storeToFill.dispatch(getCompanyData())
  }
}
